import {defineCustomElement} from 'extensions/ui-utils';
import {LitElement} from 'lit';

export class BuilderSetGroupContainer extends LitElement {
	static get properties () {
		return {};
	}

	constructor () {
		super();
	}

	createRenderRoot () {
		return this;
	}

	connectedCallback () {
		super.connectedCallback();

		this.addEventListener('builderset-item-remove', this.handleRemove.bind(this));
	}

	get groups () {
		return Array.from(this.children)?.filter(child => child.nodeName === 'X-BUILDERSET-GROUP');
	}

	// eslint-disable-next-line max-lines-per-function
	handleRemove (e) {
		window.dataLayer.push({
			ecommerce: null
		});

		const groupItemCount = this.groups?.map(group => group.builderItems?.length);
		if (groupItemCount.filter(count => count > 1)?.length > 0) {
			// Single Item Removal
			const item = e.target;
			const parent = item?.closest('x-builderset-group');

			window.dataLayer.push({
				ecommerce: {
					items: [
						{
							/* eslint-disable camelcase */
							item_id: parent.code,
							item_name: parent.name,
							/* eslint-enable camelcase */
							price: parent.price,
							quantity: item.quantity
						}
					],
					value: parseFloat((parent.price * item.quantity).toFixed(2))
				},
				event: 'remove_from_cart'
			});

			return;
		}

		const gtmItems = [];
		let gtmValue = 0;

		for (const group of this.groups) {
			for (const item of group.builderItems) {
				gtmItems.push({
					/* eslint-disable camelcase */
					item_id: group.code,
					item_name: group.name,
					/* eslint-enable camelcase */
					price: group.price,
					quantity: item.quantity
				});
			}

			gtmValue += group.subtotal;
		}

		window.dataLayer.push({
			ecommerce: {
				items: gtmItems,
				value: parseFloat(gtmValue.toFixed(2))
			},
			event: 'remove_from_cart'
		});
	}

};

defineCustomElement('x-builderset-group-container', BuilderSetGroupContainer);
